import React from 'react'
import styled from '@emotion/styled/macro'
import Loader from 'components/Loader'
import useDarkMode from 'use-dark-mode'
import mq from 'mediaQuery'

function Progress({ step, isStep2, waitPercentComplete, secondsPassed }) {
  const darkMode = useDarkMode(true)
  const isDark = darkMode.value

  if (step === 'PRICE_DECISION') return null

  return (
    <ProgressContainer>
      {isStep2 === 2 ? (
        <Wrapper>
          <ProgressWrapper>
            <ProgressBar progress={waitPercentComplete} />
          </ProgressWrapper>
          <TxtWrapper>
            <H3Bold isDark={isDark}>{secondsPassed} sec</H3Bold>
          </TxtWrapper>
        </Wrapper>
      ) : isStep2 >= 3 ? (
        <></>
      ) : (
        <Loader withWrap large />
      )}
    </ProgressContainer>
  )
}

export default Progress

const TxtWrapper = styled('div')`
  display: flex;
  justify-content: flex-end;
  width: 100%;

  ${mq.medium`
    width: 170px;
  `}
`

const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  ${mq.medium`
    flex-direction: row;
  `}
`

const H3Bold = styled('div')`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 116.7%;
  color: ${({ isDark }) => (isDark ? '#fff' : 'rgba(0, 0, 0, 0.87)')};
`

const ProgressContainer = styled('div')`
  margin: 40px 0 80px;
  width: 100%;
`

const ProgressWrapper = styled('div')`
  width: 100%;
  position: relative;
  background: #b7dfb9;
  margin-bottom: 15px;

  ${mq.medium`
    width: calc(100% - 170px);
    margin-bottom: 0;
  `}
`

const ProgressBar = styled('div')`
  height: 35px;
  background: #4caf50;
  width: ${({ progress }) => `${progress}%`};
`
